export default __webpack_public_path__ + "static/media/12.ca9a7598.jpg";